(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__vtInit) { window.__vtInit(); return; }
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  var soundOwner = null; // only one video with sound across ALL sections

  function claimSound(video) {
    if (soundOwner && soundOwner !== video) { try { soundOwner.pause(); } catch (e) {} }
    soundOwner = video;
  }

  function VT(root) {
    if (root.__vt) return;
    root.__vt = this;
    var track = root.querySelector('[data-vt-track]');
    var prev = root.querySelector('[data-vt-prev]');
    var next = root.querySelector('[data-vt-next]');
    var bar = root.querySelector('[data-vt-bar]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-vt-card]'));
    var modal = root.querySelector('[data-vt-modal]');
    var player = root.querySelector('[data-vt-player]');
    var lastFocus = null, current = -1, visible = new Map(), autoTarget = null;

    root.style.setProperty('--vt-count', Math.max(cards.length, 1));

    // move modal to <body> so theme stacking contexts (sticky headers, transforms) can't trap it
    document.body.appendChild(modal);

    function autoplayOn() { return root.getAttribute('data-autoplay') === 'true' && !reduceMotion.matches; }

    /* ---------- previews ---------- */
    function ensureSrc(card) {
      var v = card.querySelector('video');
      if (v && !v.getAttribute('src') && card.dataset.video) { v.src = card.dataset.video; }
      return v;
    }
    function playPreview(card) {
      if (reduceMotion.matches) return;
      var v = ensureSrc(card); if (!v) return;
      v.muted = true;
      if (!v.__vtBound) { v.__vtBound = true; v.addEventListener('playing', function () { if (!v.paused) card.classList.add('is-playing'); }); }
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    }
    function stopPreview(card) {
      var v = card.querySelector('video'); if (!v) return;
      v.pause(); card.classList.remove('is-playing');
    }
    cards.forEach(function (card) {
      var v = card.querySelector('video'), fill = card.querySelector('.vt-card__progress i');
      if (v && fill) v.addEventListener('timeupdate', function () {
        if (v.duration) fill.style.setProperty('--p', (v.currentTime / v.duration).toFixed(3));
      });
      // desktop hover / keyboard focus preview
      card.addEventListener('mouseenter', function () { if (finePointer.matches) playPreview(card); });
      card.addEventListener('mouseleave', function () { if (finePointer.matches && card !== autoTarget) stopPreview(card); });
      card.addEventListener('focus', function () { playPreview(card); });
      card.addEventListener('blur', function () { if (card !== autoTarget) stopPreview(card); });
      card.addEventListener('click', function () { openModal(cards.indexOf(card)); });
    });

    // In-view autoplay: only the single most visible card plays (saves bandwidth on the product page)
    function syncAutoplay() {
      if (modal.classList.contains('is-open')) return;
      var best = null, br = 0;
      if (autoplayOn()) visible.forEach(function (r, c) { if (r > br) { br = r; best = c; } });
      autoTarget = br >= 0.6 ? best : null;
      cards.forEach(function (c) {
        if (c === autoTarget) playPreview(c);
        else if (!c.matches(':hover') && document.activeElement !== c) stopPreview(c);
      });
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) visible.set(e.target, e.intersectionRatio); else visible.delete(e.target);
      });
      syncAutoplay();
    }, { threshold: [0, 0.25, 0.6, 0.9] });
    cards.forEach(function (c) { io.observe(c); });
    // pause everything when the tab is hidden
    function onVisibility() { if (document.hidden) cards.forEach(stopPreview); else syncAutoplay(); }
    document.addEventListener('visibilitychange', onVisibility);
    if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', syncAutoplay);

    /* ---------- arrows + progress ---------- */
    function step() {
      var s = track.querySelector('.vt__slide');
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return s ? s.getBoundingClientRect().width + gap : track.clientWidth;
    }
    function perView() { return Math.max(1, Math.floor((track.clientWidth + 1) / step())); }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      if (bar) {
        var ratio = Math.min(1, track.clientWidth / Math.max(track.scrollWidth, 1));
        var pos = max > 0 ? track.scrollLeft / max : 0;
        bar.style.setProperty('--w', (ratio * 100) + '%');
        bar.style.setProperty('--x', (pos * (1 / ratio - 1) * 100) + '%');
      }
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * perView(), behavior: reduceMotion.matches ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * perView(), behavior: reduceMotion.matches ? 'auto' : 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    // arrow keys inside the track move focus card-to-card
    track.addEventListener('keydown', function (e) {
      var i = cards.indexOf(document.activeElement); if (i < 0) return;
      var to = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : e.key === 'Home' ? 0 : e.key === 'End' ? cards.length - 1 : null;
      if (to === null) return;
      e.preventDefault();
      to = Math.max(0, Math.min(cards.length - 1, to));
      cards[to].focus({ preventScroll: true });
      cards[to].scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'nearest', inline: 'nearest' });
    });
    update();

    /* ---------- modal ---------- */
    var mName = modal.querySelector('[data-vt-mname]'), mSport = modal.querySelector('[data-vt-msport]'),
        mQuote = modal.querySelector('[data-vt-mquote]'), mLink = modal.querySelector('[data-vt-mlink]'),
        mInfo = modal.querySelector('[data-vt-info]');

    function embedUrl(url) {
      var m = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([\w-]{11})/);
      if (m) return 'https://www.youtube-nocookie.com/embed/' + m[1] + '?autoplay=1&playsinline=1&rel=0&modestbranding=1';
      m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
      if (m) return 'https://player.vimeo.com/video/' + m[1] + '?autoplay=1&playsinline=1';
      return null;
    }
    function load(i) {
      if (!cards.length) return;
      current = (i + cards.length) % cards.length;
      var card = cards[current], d = card.dataset;
      var dc = card.style.getPropertyValue('--d');
      if (dc) modal.style.setProperty('--vt-accent', dc); else modal.style.removeProperty('--vt-accent');
      var old = player.querySelector('video'); if (old && soundOwner === old) soundOwner = null;
      player.innerHTML = '';
      if (d.video) {
        var v = document.createElement('video');
        v.src = d.video; v.controls = true; v.playsInline = true; v.autoplay = true; v.preload = 'auto';
        var img = card.querySelector('img'); if (img) v.poster = img.currentSrc || img.src;
        v.setAttribute('aria-label', d.name || '');
        player.appendChild(v);
        claimSound(v);
        v.addEventListener('play', function () { claimSound(v); });
        var p = v.play(); if (p && p.catch) p.catch(function () {});
        mInfo.classList.add('has-native-controls');
      } else if (d.videoUrl && embedUrl(d.videoUrl)) {
        if (soundOwner) { try { soundOwner.pause(); } catch (e) {} soundOwner = null; }
        var f = document.createElement('iframe');
        f.src = embedUrl(d.videoUrl); f.title = d.name || '';
        f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen'; f.allowFullscreen = true;
        player.appendChild(f);
        mInfo.classList.remove('has-native-controls');
      }
      mName.textContent = d.name || '';
      mSport.textContent = d.sport || '';
      mQuote.textContent = d.quote ? '“' + d.quote + '”' : '';
      mQuote.hidden = !d.quote;
      if (mLink) { mLink.hidden = !d.link; if (d.link) mLink.href = d.link; }
    }
    function openModal(i) {
      lastFocus = document.activeElement;
      cards.forEach(stopPreview);
      load(i);
      modal.classList.add('is-open'); modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      modal.querySelector('.vt-modal__close').focus();
      document.addEventListener('keydown', onKey);
    }
    function closeModal() {
      modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true');
      var v = player.querySelector('video'); if (v) v.pause();
      if (soundOwner === v) soundOwner = null;
      player.innerHTML = '';
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      if (lastFocus) lastFocus.focus({ preventScroll: true });
      syncAutoplay();
    }
    function onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); closeModal(); return; }
      if (e.key === 'ArrowRight' && !e.target.closest('video')) load(current + 1);
      if (e.key === 'ArrowLeft' && !e.target.closest('video')) load(current - 1);
      if (e.key === 'Tab') { // focus trap
        var f = Array.prototype.filter.call(modal.querySelectorAll('button, a[href], video, iframe'), function (el) { return !el.hidden && el.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
    Array.prototype.forEach.call(modal.querySelectorAll('[data-vt-close]'), function (b) { b.addEventListener('click', closeModal); });
    modal.querySelector('[data-vt-mprev]').addEventListener('click', function () { load(current - 1); });
    modal.querySelector('[data-vt-mnext]').addEventListener('click', function () { load(current + 1); });
    // swipe between athletes on mobile
    var sx = null;
    player.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    player.addEventListener('touchend', function (e) {
      if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; sx = null;
      if (Math.abs(dx) > 60) load(current + (dx < 0 ? 1 : -1));
    });

    // teardown for the theme editor: drop the moved modal and every document/window listener
    this.destroy = function () {
      if (modal.classList.contains('is-open')) closeModal();
      io.disconnect();
      cards.forEach(stopPreview);
      document.removeEventListener('visibilitychange', onVisibility);
      window.removeEventListener('resize', update);
      if (reduceMotion.removeEventListener) reduceMotion.removeEventListener('change', syncAutoplay);
      modal.remove();
      root.__vt = null;
    };
  }

  window.__vtInit = function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-vt]'), function (el) { new VT(el); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', window.__vtInit);
  else window.__vtInit();
  // Shopify theme editor: tear down on unload, re-init when the section is re-rendered
  document.addEventListener('shopify:section:unload', function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll('[data-vt]'), function (el) { if (el.__vt) el.__vt.destroy(); });
  });
  document.addEventListener('shopify:section:load', window.__vtInit);
})();

  } catch(e) { console.error(e); }
})();
})();
